import { DELOAD_MODES, deloadModeLabel, deloadModeOf, withDeloadMode, type DeloadMode, type ProgramBlock }
  from "../lib/programDeload";
import { EnginePick } from "./WorkoutEngine";

/** F15 4.2 — the program's ONE Deload block, under its plan line, ONE row (his 11-02 word: two choices, so the days fit):
 *  the switch, then (while ON) the one pick — Manual (the week bar's Deload switch) or Auto (proposed by the numbers or
 *  around week 7). */
export function ProgramDeloadBlock({ block, busy, onChange }: {
  block: ProgramBlock; busy: boolean; onChange: (next: ProgramBlock) => void;
}) {
  const mode = deloadModeOf(block);
  return (
    <div className="program-deload-block">
      <label className="autoapply-row wb-engine-row">
        <input type="checkbox" checked={block.progress} disabled={busy}
               onChange={(e) => onChange({ ...block, progress: e.target.checked })} />
        <span className="ht-callout">Progress automatically</span>
      </label>
      {block.progress && (
        <EnginePick name="Deload" shown={deloadModeLabel(mode)} value={mode}
                    items={DELOAD_MODES.map((m) => ({ key: m.key, label: m.label, detail: m.detail }))}
                    onPick={(k) => onChange(withDeloadMode(block, k as DeloadMode))} />
      )}
    </div>
  );
}
